import React from 'react';

import Login, { interfaces as LoginProps } from '../../Login';
import { FooterWrapper } from './styles';

export type ComponentProps = Partial<LoginProps.ComponentProps> & {
  /**
   * Optional show/hide the login button as part of the Wizard "Header". Defaults to false
   */
  showLogin?: boolean;
};

const Footer: React.FC<ComponentProps> = ({
  client_id = '',
  loginUrl = '',
  redirect_uri = '',
  linkTarget,
  showLogin = false,
  authStore
}) => {
  return (
    <FooterWrapper>
      {showLogin && (
        <Login
          client_id={client_id}
          loginUrl={loginUrl}
          redirect_uri={redirect_uri}
          linkTarget={linkTarget}
          authStore={authStore}
        />
      )}
    </FooterWrapper>
  );
};

export default Footer;
